<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">量表管理</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh">
          <template #handler="{ row }">
            <el-button
              style="color: #6fcaf7"
              icon="Edit"
              link
              @click="click_correlation(row)"
             >关联量表</el-button>
             <el-button
              style="color: #6fcaf7"
              icon="Edit"
              link
              @click="click_view(row)"
             >查看量表</el-button>
            <el-button
              style="color: #6fcaf7"
              icon="Edit"
              link
              @click="click_edit(row)"
            >编辑</el-button>
            <ConfirmButton
              style="color: #6fcaf7"
              icon="Delete"
              link
              @confirm="click_delete(row)"
            >删除</ConfirmButton>
          </template>
        </MyTable>
        <MyPagination :params="getListParams" :total="total" @get-list="getList" ref="pagination" />
      </div>
    </div>
    <Dialog
      v-model="addVisible"
      title="新增年龄分类"
      top="5vh"
      @closed="handleClosed"
    >
      <el-form class="addForm" ref="formRef" :model="formData" label-width="auto" style="padding: 20px 40px;">
        <el-form-item label="开始年龄:" prop="startAge">
            <el-input-number v-model="formData.startAge" :min="1" :max="99" />
        </el-form-item>
        <el-form-item label="结束年龄:" prop="endAge">
            <el-input-number v-model="formData.endAge" :min="1" :max="99" />
        </el-form-item>
        <el-form-item label="分类名称:" prop="name">
          <el-input v-model="formData.name"  placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="图标:" prop="remarks">
        <el-select v-model="formData.remarks" placeholder="请选择" style="width: 240px">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            />
        </el-select>
        </el-form-item>
      </el-form>
      <div class="submit-buttons">
        <el-button plain @click="addVisible = false">取消</el-button>
        <MyButton @click="click_confirm">确定</MyButton>
      </div>
    </Dialog>
    <Dialog v-model="correlationVisible" title="关联量表" top="5vh">
         <el-form class="addForm" ref="formRef1" :model="formData1" label-width="auto" style="padding: 20px 40px;">
            <el-form-item label="量表:" prop="paperId">
                <el-select v-model="formData1.paperId" placeholder="请选择" style="width: 300px">
                    <el-option
                    v-for="item in scaleList"
                    :key="item.paperId"
                    :label="item.title"
                    :value="item.paperId"
                    />
                </el-select>
            </el-form-item>
        </el-form>
        <div class="submit-buttons">
            <el-button plain @click="correlationVisible = false">取消</el-button>
            <MyButton @click="click_confirm1">确定</MyButton>
        </div>
    </Dialog>
    <Dialog v-model="lookVisible" title="查看量表" top="5vh">
        <MyTable :table-options="tableOptions1" border max-height="65vh">
          <template #handler="{ row }">
            <ConfirmButton
              style="color: #6fcaf7"
              icon="Delete"
              link
              @confirm="click_delete1(row)"
            >删除</ConfirmButton>
          </template>
        </MyTable>
         <MyPagination :params="obj" :total="total1" @get-list="getFactorScaleAgeCategoryScaleData(obj)" ref="pagination" />
    </Dialog>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import { computed, nextTick, reactive, ref } from "vue";
import MyButton from "@/components/Global/MyButton.vue";
import educationApi from "@/api/education.js";
import MyPagination from "@/components/Global/MyPagination.vue";
import Dialog from "@/components/Common/Dialog.vue";
import ConfirmButton from "@/components/Common/ConfirmButton.vue";
import { cloneDeep } from "lodash-es";
import { dayjs, ElMessage } from "element-plus";
import {
    postFactorScaleAgeCategory,
    getFactorScaleAgeCategory,
    putFactorScaleAgeCategory,
    deleteFactorScaleAgeCategory,
    getTesterappFactorscaleList,
    postFactorScaleAgeCategoryScale,
    getFactorScaleAgeCategoryScale,
    deleteFactorScaleAgeCategoryScale
} from "@/api/FactorScaleAgeCategory"
const options = [
  {
    value: '👦',
    label: '👦',
  },
  {
    value: '🧑',
    label: '🧑',
  },
  {
    value: '👨',
    label: '👨',
  },
  {
    value: '👴',
    label: '👴',
  },
]
// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "input",
      label: "关键字：",
      prop: "Title",
      attrs: {
        placeholder: "请输入",
      }
    },
    {
      type: "Button",
      value: "查询",
      attrs: {
        icon: "Search",
      },
      events: {
        click(formData) {
          Object.assign(getListParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "重置",
      attrs: {
        icon: "Refresh",
      },
      events: {
        click(formData) {
          formData.Title = "";
          Object.assign(getListParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "新增",
      attrs: {
        icon: "Plus",
      },
      events: {
        click(formData) {
          addVisible.value = true;
        },
      },
    },
  ],
});

const tableOptions = reactive({
  colList: [
    { type: "index", label: "序号", width: 60 },
    { label: "开始年龄", prop: "startAge",},
    { label: "结束年龄", prop: "endAge" },
    { label: "分类名称", prop: "name" },
    { label: "图标" , prop: "remarks", },
    { type: "slot", slot_name: "handler", label: "操作", width: 300 },
  ],
  tableData: [],
});

// 分页
const pagination = ref();
const total = ref(0);
const getListParams = reactive({
  
})
const getList = (params = pagination.value.getList_Params) => {
  getFactorScaleAgeCategory(params).then((res) => {
    console.log(res,"量表年龄")
    tableOptions.tableData = res.data.items
    total.value = res.data.totalCount;
  })
}

// 删除
const click_delete = (row) => {
  deleteFactorScaleAgeCategory(row).then((res) => {
    ElMessage.success("删除成功");
    getList();
  })
};
// 编辑
const click_edit = (row) => {
  readonly.value = false;
  addVisible.value = true;
  formData.value = cloneDeep(row);
};
// 新增
const addVisible = ref(false);
const readonly = ref(false);
const formData = ref({
  remarks: "",
  name: "",
  startAge: 0,
  endAge:0,
});

const formRef = ref(null);
const click_confirm = async () => {

  formRef.value.validate(async (valid) => {
    if (valid) {
      formData.value.id ? await putFactorScaleAgeCategory(formData.value)
      : await postFactorScaleAgeCategory(formData.value)
      ElMessage.success(`${formData.value.id ? '编辑' : '新增'}成功`);
      addVisible.value = false;
      getList();
    }
  })
};
// 弹框关闭回调
const handleClosed = () => {
  clearForm();
};
// 清空表单值
const clearForm = () => {
  formData.value = {
    remarks: "",
    name: "",
    startAge: 0,
    endAge:0,
  };
};

//关联
const correlationVisible=ref(false)
const formData1=ref({
    factorScaleAgeCategoryId:"",
    paperId:null,
    paperTitle:"",
    remarks:"",
})
const scaleList=ref([])
const getTesterappFactorscaleListData=()=>{
    getTesterappFactorscaleList().then(res=>{
        scaleList.value=res.data
        console.log(res,"全部量表")
    })
}
getTesterappFactorscaleListData()
const click_correlation=(row)=>{
      formData1.value.factorScaleAgeCategoryId=row.id
      correlationVisible.value=true
}
const formRef1 = ref(null);
const click_confirm1 = async () => {
  formRef1.value.validate(async (valid) => {
    if (valid) {
         const result = scaleList.value.find(item => item.paperId == formData1.value.paperId);
         formData1.value.paperTitle=result.title
         await postFactorScaleAgeCategoryScale(formData1.value)
         ElMessage.success(`关联成功`);
         correlationVisible.value=false
    }
  })
};
const tableOptions1 = reactive({
  colList: [
    { type: "index", label: "序号", width: 60 },
    { label: "量表名称", prop: "paperTitle",},
    { label: "创建时间", prop: "creationTime" },
    { type: "slot", slot_name: "handler", label: "操作", width: 300 },
  ],
  tableData: [],
});
const lookVisible=ref(false)
const total1=ref(0)
const obj=reactive({
    FactorScaleAgeCategoryId:""
})
const click_view=(row)=>{
     lookVisible.value=true
    obj.FactorScaleAgeCategoryId=row.id
}
const getFactorScaleAgeCategoryScaleData=(data)=>{
    getFactorScaleAgeCategoryScale(data).then(res=>{
        tableOptions1.tableData=res.data.items
        total1.value=res.data.totalCount
        console.log(res,"分层")
    })
}
// 删除
const click_delete1 = (row) => {
  deleteFactorScaleAgeCategoryScale(row).then((res) => {
    ElMessage.success("删除成功");
    getFactorScaleAgeCategoryScaleData();
  })
};
</script>

<style lang="scss" scoped>
.cover_img {
  width: 100px;
  height: 70px;
  border-radius: 8px;
  cursor: pointer;
}
</style>
